import { render } from "./ManageCareOverlay.vue?vue&type=template&id=68ff0b0a&scoped=true&lang=pug"
import script from "./ManageCareOverlay.vue?vue&type=script&lang=js"
export * from "./ManageCareOverlay.vue?vue&type=script&lang=js"

import "./ManageCareOverlay.vue?vue&type=style&index=0&id=68ff0b0a&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68ff0b0a"]])

export default __exports__